/**
 *
 * InstituteTypeFilter
 *
 */
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { InstituteTypePicker } from 'app/components/pickers/AutocompletePickers/InstituteTypePicker';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const InstituteTypeFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <InstituteTypePicker
      onChange={handleOnChange}
      value={props.value as Entity<number> | undefined}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      size="small"
      ariaLabel={props.label}
      id={props.id}
    />
  );
};
export default InstituteTypeFilter;
